module.exports = __webpack_public_path__ + "static/media/clear_chartOLD.2515c0af.png";